//# sourceMappingURL=proposal.mjs.map
/// <reference types="./proposal.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $mime_types from "../../mime_types/mime_types.mjs";
import * as $list_ from "../../tiamat/gleam/list_.mjs";
import * as $timestamp_ from "../../tiamat/gleam/time/timestamp_.mjs";
import * as $data_source from "../data/data_source.mjs";
import * as $origin from "../data/proposal/origin.mjs";
import * as $cell_mapping from "../data/proposal_element/cell_mapping.mjs";
import * as $question from "../data/proposal_element/question.mjs";
import * as $qualification_matrix from "../data/qualification_matrix.mjs";
import * as $spreadsheet from "../data/spreadsheet.mjs";
import * as $status from "../data/status.mjs";
import * as $style_guideline from "../data/style_guideline.mjs";
import * as $tag from "../data/tag.mjs";
import * as $language from "../data/translate/language.mjs";
import * as $iso639 from "../data/translate/language/iso639.mjs";
import * as $decrypt from "../decrypt.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
  isEqual,
} from "../gleam.mjs";

export class QuestionnaireResponse extends $CustomType {
  constructor(name, column, kind) {
    super();
    this.name = name;
    this.column = column;
    this.kind = kind;
  }
}
export const QuestionnaireResponse$QuestionnaireResponse = (name, column, kind) =>
  new QuestionnaireResponse(name, column, kind);
export const QuestionnaireResponse$isQuestionnaireResponse = (value) =>
  value instanceof QuestionnaireResponse;
export const QuestionnaireResponse$QuestionnaireResponse$name = (value) =>
  value.name;
export const QuestionnaireResponse$QuestionnaireResponse$0 = (value) =>
  value.name;
export const QuestionnaireResponse$QuestionnaireResponse$column = (value) =>
  value.column;
export const QuestionnaireResponse$QuestionnaireResponse$1 = (value) =>
  value.column;
export const QuestionnaireResponse$QuestionnaireResponse$kind = (value) =>
  value.kind;
export const QuestionnaireResponse$QuestionnaireResponse$2 = (value) =>
  value.kind;

export class OneTrust extends $CustomType {}
export const PortalType$OneTrust = () => new OneTrust();
export const PortalType$isOneTrust = (value) => value instanceof OneTrust;

export class V1 extends $CustomType {}
export const Version$V1 = () => new V1();
export const Version$isV1 = (value) => value instanceof V1;

export class V2 extends $CustomType {}
export const Version$V2 = () => new V2();
export const Version$isV2 = (value) => value instanceof V2;

/**
 * Breaking change, change of the mapping format.
 */
export class V3 extends $CustomType {}
export const Version$V3 = () => new V3();
export const Version$isV3 = (value) => value instanceof V3;

/**
 * The worksheet's `cell_mapping` is the only mapping — the legacy
 * `columns_type`/`rows_type` fields stay on the wire but are emptied at
 * submission, so every existing decoder keeps working on the same shape.
 */
export class V4 extends $CustomType {}
export const Version$V4 = () => new V4();
export const Version$isV4 = (value) => value instanceof V4;

export class Portal extends $CustomType {
  constructor(source_filters, style_guidelines, proposal_context, languages, qualification_matrix, default_language, notified, project_file_id, origin, portal) {
    super();
    this.source_filters = source_filters;
    this.style_guidelines = style_guidelines;
    this.proposal_context = proposal_context;
    this.languages = languages;
    this.qualification_matrix = qualification_matrix;
    this.default_language = default_language;
    this.notified = notified;
    this.project_file_id = project_file_id;
    this.origin = origin;
    this.portal = portal;
  }
}
export const Metadata$Portal = (source_filters, style_guidelines, proposal_context, languages, qualification_matrix, default_language, notified, project_file_id, origin, portal) =>
  new Portal(source_filters,
  style_guidelines,
  proposal_context,
  languages,
  qualification_matrix,
  default_language,
  notified,
  project_file_id,
  origin,
  portal);
export const Metadata$isPortal = (value) => value instanceof Portal;
export const Metadata$Portal$source_filters = (value) => value.source_filters;
export const Metadata$Portal$0 = (value) => value.source_filters;
export const Metadata$Portal$style_guidelines = (value) =>
  value.style_guidelines;
export const Metadata$Portal$1 = (value) => value.style_guidelines;
export const Metadata$Portal$proposal_context = (value) =>
  value.proposal_context;
export const Metadata$Portal$2 = (value) => value.proposal_context;
export const Metadata$Portal$languages = (value) => value.languages;
export const Metadata$Portal$3 = (value) => value.languages;
export const Metadata$Portal$qualification_matrix = (value) =>
  value.qualification_matrix;
export const Metadata$Portal$4 = (value) => value.qualification_matrix;
export const Metadata$Portal$default_language = (value) =>
  value.default_language;
export const Metadata$Portal$5 = (value) => value.default_language;
export const Metadata$Portal$notified = (value) => value.notified;
export const Metadata$Portal$6 = (value) => value.notified;
export const Metadata$Portal$project_file_id = (value) => value.project_file_id;
export const Metadata$Portal$7 = (value) => value.project_file_id;
export const Metadata$Portal$origin = (value) => value.origin;
export const Metadata$Portal$8 = (value) => value.origin;
export const Metadata$Portal$portal = (value) => value.portal;
export const Metadata$Portal$9 = (value) => value.portal;

export class Document extends $CustomType {
  constructor(source_filters, style_guidelines, proposal_context, languages, qualification_matrix, default_language, notified, project_file_id, origin) {
    super();
    this.source_filters = source_filters;
    this.style_guidelines = style_guidelines;
    this.proposal_context = proposal_context;
    this.languages = languages;
    this.qualification_matrix = qualification_matrix;
    this.default_language = default_language;
    this.notified = notified;
    this.project_file_id = project_file_id;
    this.origin = origin;
  }
}
export const Metadata$Document = (source_filters, style_guidelines, proposal_context, languages, qualification_matrix, default_language, notified, project_file_id, origin) =>
  new Document(source_filters,
  style_guidelines,
  proposal_context,
  languages,
  qualification_matrix,
  default_language,
  notified,
  project_file_id,
  origin);
export const Metadata$isDocument = (value) => value instanceof Document;
export const Metadata$Document$source_filters = (value) => value.source_filters;
export const Metadata$Document$0 = (value) => value.source_filters;
export const Metadata$Document$style_guidelines = (value) =>
  value.style_guidelines;
export const Metadata$Document$1 = (value) => value.style_guidelines;
export const Metadata$Document$proposal_context = (value) =>
  value.proposal_context;
export const Metadata$Document$2 = (value) => value.proposal_context;
export const Metadata$Document$languages = (value) => value.languages;
export const Metadata$Document$3 = (value) => value.languages;
export const Metadata$Document$qualification_matrix = (value) =>
  value.qualification_matrix;
export const Metadata$Document$4 = (value) => value.qualification_matrix;
export const Metadata$Document$default_language = (value) =>
  value.default_language;
export const Metadata$Document$5 = (value) => value.default_language;
export const Metadata$Document$notified = (value) => value.notified;
export const Metadata$Document$6 = (value) => value.notified;
export const Metadata$Document$project_file_id = (value) =>
  value.project_file_id;
export const Metadata$Document$7 = (value) => value.project_file_id;
export const Metadata$Document$origin = (value) => value.origin;
export const Metadata$Document$8 = (value) => value.origin;

export class Questionnaire extends $CustomType {
  constructor(source_filters, style_guidelines, proposal_context, languages, qualification_matrix, default_language, notified, project_file_id, origin, sheets, responses, worksheets, worksheets_key, section_labels) {
    super();
    this.source_filters = source_filters;
    this.style_guidelines = style_guidelines;
    this.proposal_context = proposal_context;
    this.languages = languages;
    this.qualification_matrix = qualification_matrix;
    this.default_language = default_language;
    this.notified = notified;
    this.project_file_id = project_file_id;
    this.origin = origin;
    this.sheets = sheets;
    this.responses = responses;
    this.worksheets = worksheets;
    this.worksheets_key = worksheets_key;
    this.section_labels = section_labels;
  }
}
export const Metadata$Questionnaire = (source_filters, style_guidelines, proposal_context, languages, qualification_matrix, default_language, notified, project_file_id, origin, sheets, responses, worksheets, worksheets_key, section_labels) =>
  new Questionnaire(source_filters,
  style_guidelines,
  proposal_context,
  languages,
  qualification_matrix,
  default_language,
  notified,
  project_file_id,
  origin,
  sheets,
  responses,
  worksheets,
  worksheets_key,
  section_labels);
export const Metadata$isQuestionnaire = (value) =>
  value instanceof Questionnaire;
export const Metadata$Questionnaire$source_filters = (value) =>
  value.source_filters;
export const Metadata$Questionnaire$0 = (value) => value.source_filters;
export const Metadata$Questionnaire$style_guidelines = (value) =>
  value.style_guidelines;
export const Metadata$Questionnaire$1 = (value) => value.style_guidelines;
export const Metadata$Questionnaire$proposal_context = (value) =>
  value.proposal_context;
export const Metadata$Questionnaire$2 = (value) => value.proposal_context;
export const Metadata$Questionnaire$languages = (value) => value.languages;
export const Metadata$Questionnaire$3 = (value) => value.languages;
export const Metadata$Questionnaire$qualification_matrix = (value) =>
  value.qualification_matrix;
export const Metadata$Questionnaire$4 = (value) => value.qualification_matrix;
export const Metadata$Questionnaire$default_language = (value) =>
  value.default_language;
export const Metadata$Questionnaire$5 = (value) => value.default_language;
export const Metadata$Questionnaire$notified = (value) => value.notified;
export const Metadata$Questionnaire$6 = (value) => value.notified;
export const Metadata$Questionnaire$project_file_id = (value) =>
  value.project_file_id;
export const Metadata$Questionnaire$7 = (value) => value.project_file_id;
export const Metadata$Questionnaire$origin = (value) => value.origin;
export const Metadata$Questionnaire$8 = (value) => value.origin;
export const Metadata$Questionnaire$sheets = (value) => value.sheets;
export const Metadata$Questionnaire$9 = (value) => value.sheets;
export const Metadata$Questionnaire$responses = (value) => value.responses;
export const Metadata$Questionnaire$10 = (value) => value.responses;
export const Metadata$Questionnaire$worksheets = (value) => value.worksheets;
export const Metadata$Questionnaire$11 = (value) => value.worksheets;
export const Metadata$Questionnaire$worksheets_key = (value) =>
  value.worksheets_key;
export const Metadata$Questionnaire$12 = (value) => value.worksheets_key;
export const Metadata$Questionnaire$section_labels = (value) =>
  value.section_labels;
export const Metadata$Questionnaire$13 = (value) => value.section_labels;

export class Narrative extends $CustomType {
  constructor(source_filters, style_guidelines, proposal_context, languages, qualification_matrix, default_language, notified, project_file_id, origin, requirements) {
    super();
    this.source_filters = source_filters;
    this.style_guidelines = style_guidelines;
    this.proposal_context = proposal_context;
    this.languages = languages;
    this.qualification_matrix = qualification_matrix;
    this.default_language = default_language;
    this.notified = notified;
    this.project_file_id = project_file_id;
    this.origin = origin;
    this.requirements = requirements;
  }
}
export const Metadata$Narrative = (source_filters, style_guidelines, proposal_context, languages, qualification_matrix, default_language, notified, project_file_id, origin, requirements) =>
  new Narrative(source_filters,
  style_guidelines,
  proposal_context,
  languages,
  qualification_matrix,
  default_language,
  notified,
  project_file_id,
  origin,
  requirements);
export const Metadata$isNarrative = (value) => value instanceof Narrative;
export const Metadata$Narrative$source_filters = (value) =>
  value.source_filters;
export const Metadata$Narrative$0 = (value) => value.source_filters;
export const Metadata$Narrative$style_guidelines = (value) =>
  value.style_guidelines;
export const Metadata$Narrative$1 = (value) => value.style_guidelines;
export const Metadata$Narrative$proposal_context = (value) =>
  value.proposal_context;
export const Metadata$Narrative$2 = (value) => value.proposal_context;
export const Metadata$Narrative$languages = (value) => value.languages;
export const Metadata$Narrative$3 = (value) => value.languages;
export const Metadata$Narrative$qualification_matrix = (value) =>
  value.qualification_matrix;
export const Metadata$Narrative$4 = (value) => value.qualification_matrix;
export const Metadata$Narrative$default_language = (value) =>
  value.default_language;
export const Metadata$Narrative$5 = (value) => value.default_language;
export const Metadata$Narrative$notified = (value) => value.notified;
export const Metadata$Narrative$6 = (value) => value.notified;
export const Metadata$Narrative$project_file_id = (value) =>
  value.project_file_id;
export const Metadata$Narrative$7 = (value) => value.project_file_id;
export const Metadata$Narrative$origin = (value) => value.origin;
export const Metadata$Narrative$8 = (value) => value.origin;
export const Metadata$Narrative$requirements = (value) => value.requirements;
export const Metadata$Narrative$9 = (value) => value.requirements;

export const Metadata$default_language = (value) => value.default_language;
export const Metadata$languages = (value) => value.languages;
export const Metadata$notified = (value) => value.notified;
export const Metadata$origin = (value) => value.origin;
export const Metadata$project_file_id = (value) => value.project_file_id;
export const Metadata$proposal_context = (value) => value.proposal_context;
export const Metadata$qualification_matrix = (value) =>
  value.qualification_matrix;
export const Metadata$source_filters = (value) => value.source_filters;
export const Metadata$style_guidelines = (value) => value.style_guidelines;

export class Display extends $CustomType {
  constructor(type_, syncing) {
    super();
    this.type_ = type_;
    this.syncing = syncing;
  }
}
export const Display$Display = (type_, syncing) => new Display(type_, syncing);
export const Display$isDisplay = (value) => value instanceof Display;
export const Display$Display$type_ = (value) => value.type_;
export const Display$Display$0 = (value) => value.type_;
export const Display$Display$syncing = (value) => value.syncing;
export const Display$Display$1 = (value) => value.syncing;

export class Sheets extends $CustomType {}
export const ProposalKind$Sheets = () => new Sheets();
export const ProposalKind$isSheets = (value) => value instanceof Sheets;

export class Doc extends $CustomType {}
export const ProposalKind$Doc = () => new Doc();
export const ProposalKind$isDoc = (value) => value instanceof Doc;

export class Proposal extends $CustomType {
  constructor(id, project_id, org_id, name, status, display, google_sheet_id, kind, link_id, domain, metadata, progress, created_at, version) {
    super();
    this.id = id;
    this.project_id = project_id;
    this.org_id = org_id;
    this.name = name;
    this.status = status;
    this.display = display;
    this.google_sheet_id = google_sheet_id;
    this.kind = kind;
    this.link_id = link_id;
    this.domain = domain;
    this.metadata = metadata;
    this.progress = progress;
    this.created_at = created_at;
    this.version = version;
  }
}
export const Proposal$Proposal = (id, project_id, org_id, name, status, display, google_sheet_id, kind, link_id, domain, metadata, progress, created_at, version) =>
  new Proposal(id,
  project_id,
  org_id,
  name,
  status,
  display,
  google_sheet_id,
  kind,
  link_id,
  domain,
  metadata,
  progress,
  created_at,
  version);
export const Proposal$isProposal = (value) => value instanceof Proposal;
export const Proposal$Proposal$id = (value) => value.id;
export const Proposal$Proposal$0 = (value) => value.id;
export const Proposal$Proposal$project_id = (value) => value.project_id;
export const Proposal$Proposal$1 = (value) => value.project_id;
export const Proposal$Proposal$org_id = (value) => value.org_id;
export const Proposal$Proposal$2 = (value) => value.org_id;
export const Proposal$Proposal$name = (value) => value.name;
export const Proposal$Proposal$3 = (value) => value.name;
export const Proposal$Proposal$status = (value) => value.status;
export const Proposal$Proposal$4 = (value) => value.status;
export const Proposal$Proposal$display = (value) => value.display;
export const Proposal$Proposal$5 = (value) => value.display;
export const Proposal$Proposal$google_sheet_id = (value) =>
  value.google_sheet_id;
export const Proposal$Proposal$6 = (value) => value.google_sheet_id;
export const Proposal$Proposal$kind = (value) => value.kind;
export const Proposal$Proposal$7 = (value) => value.kind;
export const Proposal$Proposal$link_id = (value) => value.link_id;
export const Proposal$Proposal$8 = (value) => value.link_id;
export const Proposal$Proposal$domain = (value) => value.domain;
export const Proposal$Proposal$9 = (value) => value.domain;
export const Proposal$Proposal$metadata = (value) => value.metadata;
export const Proposal$Proposal$10 = (value) => value.metadata;
export const Proposal$Proposal$progress = (value) => value.progress;
export const Proposal$Proposal$11 = (value) => value.progress;
export const Proposal$Proposal$created_at = (value) => value.created_at;
export const Proposal$Proposal$12 = (value) => value.created_at;
export const Proposal$Proposal$version = (value) => value.version;
export const Proposal$Proposal$13 = (value) => value.version;

export class StatusField extends $CustomType {}
export const FilterField$StatusField = () => new StatusField();
export const FilterField$isStatusField = (value) =>
  value instanceof StatusField;

export class OwnerField extends $CustomType {}
export const FilterField$OwnerField = () => new OwnerField();
export const FilterField$isOwnerField = (value) => value instanceof OwnerField;

export class ConfidenceField extends $CustomType {}
export const FilterField$ConfidenceField = () => new ConfidenceField();
export const FilterField$isConfidenceField = (value) =>
  value instanceof ConfidenceField;

export class SectionField extends $CustomType {}
export const FilterField$SectionField = () => new SectionField();
export const FilterField$isSectionField = (value) =>
  value instanceof SectionField;

export class CommentsField extends $CustomType {}
export const FilterField$CommentsField = () => new CommentsField();
export const FilterField$isCommentsField = (value) =>
  value instanceof CommentsField;

export class MentionsField extends $CustomType {}
export const FilterField$MentionsField = () => new MentionsField();
export const FilterField$isMentionsField = (value) =>
  value instanceof MentionsField;

export class EditedByField extends $CustomType {}
export const FilterField$EditedByField = () => new EditedByField();
export const FilterField$isEditedByField = (value) =>
  value instanceof EditedByField;

export class WrittenByField extends $CustomType {}
export const FilterField$WrittenByField = () => new WrittenByField();
export const FilterField$isWrittenByField = (value) =>
  value instanceof WrittenByField;

export class SourcesField extends $CustomType {}
export const FilterField$SourcesField = () => new SourcesField();
export const FilterField$isSourcesField = (value) =>
  value instanceof SourcesField;

export class AnswerTypeField extends $CustomType {}
export const FilterField$AnswerTypeField = () => new AnswerTypeField();
export const FilterField$isAnswerTypeField = (value) =>
  value instanceof AnswerTypeField;

export class MissingTranslationField extends $CustomType {}
export const FilterField$MissingTranslationField = () =>
  new MissingTranslationField();
export const FilterField$isMissingTranslationField = (value) =>
  value instanceof MissingTranslationField;

export class ProposalFilters extends $CustomType {
  constructor(active) {
    super();
    this.active = active;
  }
}
export const ProposalFilters$ProposalFilters = (active) =>
  new ProposalFilters(active);
export const ProposalFilters$isProposalFilters = (value) =>
  value instanceof ProposalFilters;
export const ProposalFilters$ProposalFilters$active = (value) => value.active;
export const ProposalFilters$ProposalFilters$0 = (value) => value.active;

export class SectionCell extends $CustomType {
  constructor(sheet_name, position, text) {
    super();
    this.sheet_name = sheet_name;
    this.position = position;
    this.text = text;
  }
}
export const SectionCell$SectionCell = (sheet_name, position, text) =>
  new SectionCell(sheet_name, position, text);
export const SectionCell$isSectionCell = (value) =>
  value instanceof SectionCell;
export const SectionCell$SectionCell$sheet_name = (value) => value.sheet_name;
export const SectionCell$SectionCell$0 = (value) => value.sheet_name;
export const SectionCell$SectionCell$position = (value) => value.position;
export const SectionCell$SectionCell$1 = (value) => value.position;
export const SectionCell$SectionCell$text = (value) => value.text;
export const SectionCell$SectionCell$2 = (value) => value.text;

export function new_filters() {
  return new ProposalFilters(toList([]));
}

function not_empty(str) {
  if (str instanceof Some) {
    let $ = str[0];
    if ($ === "") {
      return new None();
    } else {
      return str;
    }
  } else {
    return new None();
  }
}

export function version_to_int(version) {
  if (version instanceof V1) {
    return 1;
  } else if (version instanceof V2) {
    return 2;
  } else if (version instanceof V3) {
    return 3;
  } else {
    return 4;
  }
}

function encode_version(version) {
  let _pipe = version;
  let _pipe$1 = version_to_int(_pipe);
  return $json.int(_pipe$1);
}

export function encode_kind(kind) {
  if (kind instanceof Sheets) {
    return "sheets";
  } else {
    return "doc";
  }
}

function without_grids(metadata) {
  if (metadata instanceof Questionnaire) {
    let $ = metadata.worksheets_key;
    if ($ instanceof Some) {
      let questionnaire = metadata;
      return new Questionnaire(
        questionnaire.source_filters,
        questionnaire.style_guidelines,
        questionnaire.proposal_context,
        questionnaire.languages,
        questionnaire.qualification_matrix,
        questionnaire.default_language,
        questionnaire.notified,
        questionnaire.project_file_id,
        questionnaire.origin,
        questionnaire.sheets,
        questionnaire.responses,
        toList([]),
        questionnaire.worksheets_key,
        questionnaire.section_labels,
      );
    } else {
      return metadata;
    }
  } else {
    return metadata;
  }
}

function encode_portal_type(portal_type) {
  return $json.string("one_trust");
}

export function encode_metadata(metadata) {
  if (metadata instanceof Portal) {
    return $json.object(
      toList([
        ["type", $json.string("portal")],
        ["portal", encode_portal_type(metadata.portal)],
        [
          "languages",
          $json.array(
            metadata.languages,
            (language) => { return $iso639.encode(language); },
          ),
        ],
        [
          "default_language",
          $json.nullable(
            metadata.default_language,
            (language) => { return $iso639.encode(language); },
          ),
        ],
        [
          "source_filters",
          $data_source.source_filters_encode(metadata.source_filters),
        ],
        [
          "style_guidelines",
          $json.nullable(metadata.style_guidelines, $style_guideline.encode),
        ],
        [
          "proposal_context",
          $json.nullable(metadata.proposal_context, $json.string),
        ],
        [
          "qualification_matrix",
          $json.nullable(
            metadata.qualification_matrix,
            (q) => {
              return $json.array(
                q,
                (_use0) => {
                  let matrix = _use0[0];
                  let answer = _use0[1];
                  return $json.object(
                    toList([
                      ["item", $qualification_matrix.encode(matrix)],
                      ["state", $qualification_matrix.encode_answer(answer)],
                    ]),
                  );
                },
              );
            },
          ),
        ],
        ["notified", $json.bool(metadata.notified)],
        [
          "project_file_id",
          $json.nullable(metadata.project_file_id, $json.string),
        ],
        ["origin", $json.nullable(metadata.origin, $origin.encode)],
      ]),
    );
  } else if (metadata instanceof Document) {
    return $json.object(
      toList([
        ["type", $json.string("document")],
        [
          "languages",
          $json.array(
            metadata.languages,
            (language) => { return $json.string($iso639.to_string(language)); },
          ),
        ],
        [
          "default_language",
          $json.nullable(
            metadata.default_language,
            (language) => { return $json.string($iso639.to_string(language)); },
          ),
        ],
        [
          "source_filters",
          $data_source.source_filters_encode(metadata.source_filters),
        ],
        [
          "style_guidelines",
          $json.nullable(metadata.style_guidelines, $style_guideline.encode),
        ],
        [
          "proposal_context",
          $json.nullable(metadata.proposal_context, $json.string),
        ],
        [
          "qualification_matrix",
          $json.nullable(
            metadata.qualification_matrix,
            (q) => {
              return $json.array(
                q,
                (_use0) => {
                  let matrix = _use0[0];
                  let answer = _use0[1];
                  return $json.object(
                    toList([
                      ["item", $qualification_matrix.encode(matrix)],
                      ["state", $qualification_matrix.encode_answer(answer)],
                    ]),
                  );
                },
              );
            },
          ),
        ],
        ["notified", $json.bool(metadata.notified)],
        [
          "project_file_id",
          $json.nullable(metadata.project_file_id, $json.string),
        ],
        ["origin", $json.nullable(metadata.origin, $origin.encode)],
      ]),
    );
  } else if (metadata instanceof Questionnaire) {
    return $json.object(
      toList([
        ["type", $json.string("questionnaire")],
        ["languages", $json.array(metadata.languages, $iso639.encode)],
        [
          "default_language",
          $json.nullable(metadata.default_language, $iso639.encode),
        ],
        [
          "source_filters",
          $data_source.source_filters_encode(metadata.source_filters),
        ],
        [
          "style_guidelines",
          $json.nullable(metadata.style_guidelines, $style_guideline.encode),
        ],
        [
          "proposal_context",
          $json.nullable(metadata.proposal_context, $json.string),
        ],
        ["sheets", $json.array(metadata.sheets, $json.string)],
        [
          "responses",
          $json.array(
            metadata.responses,
            (response) => {
              return $json.object(
                toList([
                  ["name", $json.string(response.name)],
                  ["column", $json.int(response.column)],
                  ["kind", $question.encode_answer_kind(response.kind)],
                ]),
              );
            },
          ),
        ],
        [
          "worksheets",
          $json.array(
            metadata.worksheets,
            (w) => { return $spreadsheet.encode_worksheet(w); },
          ),
        ],
        [
          "worksheets_key",
          $json.nullable(metadata.worksheets_key, $json.string),
        ],
        [
          "section_labels",
          $json.nullable(
            metadata.section_labels,
            (_capture) => { return $json.array(_capture, $json.string); },
          ),
        ],
        [
          "qualification_matrix",
          $json.nullable(
            metadata.qualification_matrix,
            (q) => {
              return $json.array(
                q,
                (_use0) => {
                  let matrix = _use0[0];
                  let answer = _use0[1];
                  return $json.object(
                    toList([
                      ["item", $qualification_matrix.encode(matrix)],
                      ["state", $qualification_matrix.encode_answer(answer)],
                    ]),
                  );
                },
              );
            },
          ),
        ],
        ["notified", $json.bool(metadata.notified)],
        [
          "project_file_id",
          $json.nullable(metadata.project_file_id, $json.string),
        ],
        ["origin", $json.nullable(metadata.origin, $origin.encode)],
      ]),
    );
  } else {
    return $json.object(
      toList([
        ["type", $json.string("narrative")],
        [
          "languages",
          $json.array(
            metadata.languages,
            (language) => { return $json.string($iso639.to_string(language)); },
          ),
        ],
        [
          "default_language",
          $json.nullable(
            metadata.default_language,
            (language) => { return $json.string($iso639.to_string(language)); },
          ),
        ],
        [
          "source_filters",
          $data_source.source_filters_encode(metadata.source_filters),
        ],
        [
          "style_guidelines",
          $json.nullable(metadata.style_guidelines, $style_guideline.encode),
        ],
        [
          "proposal_context",
          $json.nullable(metadata.proposal_context, $json.string),
        ],
        [
          "qualification_matrix",
          $json.nullable(
            metadata.qualification_matrix,
            (q) => {
              return $json.array(
                q,
                (_use0) => {
                  let matrix = _use0[0];
                  let answer = _use0[1];
                  return $json.object(
                    toList([
                      ["item", $qualification_matrix.encode(matrix)],
                      ["state", $qualification_matrix.encode_answer(answer)],
                    ]),
                  );
                },
              );
            },
          ),
        ],
        ["notified", $json.bool(metadata.notified)],
        [
          "project_file_id",
          $json.nullable(metadata.project_file_id, $json.string),
        ],
        ["origin", $json.nullable(metadata.origin, $origin.encode)],
        [
          "requirements",
          $json.nullable(
            metadata.requirements,
            (_capture) => { return $json.array(_capture, $json.string); },
          ),
        ],
      ]),
    );
  }
}

/**
 * The metadata as it goes over the network — HTTP responses and WebSocket
 * pushes — with the worksheet grids left out (Pylon #1047).
 *
 * Distinct from `encode_metadata`, which is what gets persisted: the database
 * keeps the grids, and every server-side reader (mimir, labelling, mapping,
 * remap, advanced detection) goes on reading them from the row. Only the wire
 * is slimmed.
 *
 * The grids are dropped ONLY when `worksheets_key` is set. A proposal that has
 * not been backfilled has no pointer, so dropping them would make its sheets
 * unreachable — it keeps sending them inline instead. That guard is what lets
 * this ship without waiting for the backfill to drain.
 */
export function encode_metadata_for_transport(metadata) {
  return encode_metadata(without_grids(metadata));
}

export function encode_display(display) {
  return $json.object(
    toList([
      ["type", $json.string(display.type_)],
      ["syncing", $json.bool(display.syncing)],
    ]),
  );
}

export function encode(proposal) {
  return $json.object(
    toList([
      ["id", $json.string(proposal.id)],
      ["display", encode_display(proposal.display)],
      ["org_id", $json.string(proposal.org_id)],
      ["name", $json.string(proposal.name)],
      ["deadline", $timestamp_.encode($timestamp.system_time())],
      ["owner", $json.string("")],
      ["client", $json.string("")],
      ["collaborators", $json.array(toList([]), $json.string)],
      ["progress", $json.int(proposal.progress)],
      ["status", $status.encode(proposal.status)],
      ["metadata", encode_metadata_for_transport(proposal.metadata)],
      ["created_at", $timestamp_.encode(proposal.created_at)],
      ["kind", $json.string(encode_kind(proposal.kind))],
      ["project_id", $json.string(proposal.project_id)],
      [
        "google_sheet_id",
        $json.nullable(proposal.google_sheet_id, $json.string),
      ],
      ["link_id", $json.nullable(proposal.link_id, $json.string)],
      [
        "domain",
        $json.nullable(
          (() => {
            let _pipe = proposal.domain;
            return not_empty(_pipe);
          })(),
          $json.string,
        ),
      ],
      ["version", encode_version(proposal.version)],
    ]),
  );
}

/**
 * Same shape as `encode`, for the one caller that is not "the wire" in the
 * Pylon #1047 sense: heimdall's own server-to-server export request to nabu
 * (`heimdall/services/proposal/export.gleam`).
 *
 * `encode` trims worksheets via `encode_metadata_for_transport` because its
 * callers are HTTP responses and WebSocket pushes read repeatedly by the
 * frontend, the Chrome extension, and nyarlathotep — exactly the payloads
 * phase 3 was built to shrink. The export request is none of those: it is a
 * single, occasional POST straight to nabu, which needs the worksheet
 * `cell_mapping` to know which cell an answer belongs in. Without it, nabu
 * falls back to a per-sheet legacy resolver that cannot tell two questions on
 * the same sheet apart, and answers land on the wrong cell or overwrite one
 * another.
 */
export function encode_for_export(proposal) {
  return $json.object(
    toList([
      ["id", $json.string(proposal.id)],
      ["display", encode_display(proposal.display)],
      ["org_id", $json.string(proposal.org_id)],
      ["name", $json.string(proposal.name)],
      ["deadline", $timestamp_.encode($timestamp.system_time())],
      ["owner", $json.string("")],
      ["client", $json.string("")],
      ["collaborators", $json.array(toList([]), $json.string)],
      ["progress", $json.int(proposal.progress)],
      ["status", $status.encode(proposal.status)],
      ["metadata", encode_metadata(proposal.metadata)],
      ["created_at", $timestamp_.encode(proposal.created_at)],
      ["kind", $json.string(encode_kind(proposal.kind))],
      ["project_id", $json.string(proposal.project_id)],
      [
        "google_sheet_id",
        $json.nullable(proposal.google_sheet_id, $json.string),
      ],
      ["link_id", $json.nullable(proposal.link_id, $json.string)],
      [
        "domain",
        $json.nullable(
          (() => {
            let _pipe = proposal.domain;
            return not_empty(_pipe);
          })(),
          $json.string,
        ),
      ],
      ["version", encode_version(proposal.version)],
    ]),
  );
}

export function filter_field_to_string(field) {
  if (field instanceof StatusField) {
    return "status";
  } else if (field instanceof OwnerField) {
    return "owner";
  } else if (field instanceof ConfidenceField) {
    return "confidence";
  } else if (field instanceof SectionField) {
    return "section";
  } else if (field instanceof CommentsField) {
    return "comments";
  } else if (field instanceof MentionsField) {
    return "mentions";
  } else if (field instanceof EditedByField) {
    return "edited_by";
  } else if (field instanceof WrittenByField) {
    return "written_by";
  } else if (field instanceof SourcesField) {
    return "sources";
  } else if (field instanceof AnswerTypeField) {
    return "answer_type";
  } else {
    return "missing_translation";
  }
}

export function encode_proposal_filters(proposal_filters) {
  return $json.object(
    toList([
      [
        "active",
        $json.array(
          proposal_filters.active,
          (entry) => {
            return $json.object(
              toList([
                ["field", $json.string(filter_field_to_string(entry[0]))],
                ["values", $json.array(entry[1], $json.string)],
              ]),
            );
          },
        ),
      ],
    ]),
  );
}

function filter_field_decoder() {
  return $decode.then$(
    $decode.string,
    (variant) => {
      if (variant === "status") {
        return $decode.success(new StatusField());
      } else if (variant === "owner") {
        return $decode.success(new OwnerField());
      } else if (variant === "confidence") {
        return $decode.success(new ConfidenceField());
      } else if (variant === "section") {
        return $decode.success(new SectionField());
      } else if (variant === "comments") {
        return $decode.success(new CommentsField());
      } else if (variant === "mentions") {
        return $decode.success(new MentionsField());
      } else if (variant === "edited_by") {
        return $decode.success(new EditedByField());
      } else if (variant === "written_by") {
        return $decode.success(new WrittenByField());
      } else if (variant === "sources") {
        return $decode.success(new SourcesField());
      } else if (variant === "answer_type") {
        return $decode.success(new AnswerTypeField());
      } else if (variant === "missing_translation") {
        return $decode.success(new MissingTranslationField());
      } else {
        return $decode.failure(new StatusField(), "FilterField");
      }
    },
  );
}

export function proposal_filters_decoder() {
  return $decode.field(
    "active",
    $decode.list(
      $decode.field(
        "field",
        filter_field_decoder(),
        (field) => {
          return $decode.field(
            "values",
            $decode.list($decode.string),
            (values) => { return $decode.success([field, values]); },
          );
        },
      ),
    ),
    (active) => { return $decode.success(new ProposalFilters(active)); },
  );
}

function version_decoder() {
  return $decode.then$(
    $decode.int,
    (content) => {
      if (content === 1) {
        return $decode.success(new V1());
      } else if (content === 2) {
        return $decode.success(new V2());
      } else if (content === 3) {
        return $decode.success(new V3());
      } else if (content === 4) {
        return $decode.success(new V4());
      } else {
        return $decode.failure(new V1(), "Version");
      }
    },
  );
}

export function kind_to_file_extension(kind) {
  if (kind instanceof Sheets) {
    return ".xlsx";
  } else {
    return ".docx";
  }
}

export function kind_decoder() {
  return $decode.then$(
    $decode.string,
    (kind) => {
      if (kind === "doc") {
        return $decode.success(new Doc());
      } else if (kind === "sheets") {
        return $decode.success(new Sheets());
      } else {
        return $decode.failure(new Doc(), "Kind");
      }
    },
  );
}

function decode_questionnaire_response() {
  return $decode.field(
    "name",
    $decode.string,
    (name) => {
      return $decode.field(
        "column",
        $decode.int,
        (column) => {
          let question_type = $question.answer_kind_decoder();
          return $decrypt.optional_field(
            "kind",
            question_type,
            (kind) => {
              let kind$1 = $option.unwrap(kind, new $question.Long());
              return $decode.success(
                new QuestionnaireResponse(name, column, kind$1),
              );
            },
          );
        },
      );
    },
  );
}

function decode_qualification_matrix() {
  return $decode.field(
    "item",
    $qualification_matrix.decoder(),
    (item) => {
      return $decode.field(
        "state",
        $qualification_matrix.answer_decoder(),
        (state) => { return $decode.success([item, state]); },
      );
    },
  );
}

function languages_decoder() {
  let _pipe = $decode.optional($decode.list($iso639.decoder()));
  return $decode.map(
    _pipe,
    (_capture) => { return $option.unwrap(_capture, toList([])); },
  );
}

function portal_type_decoder() {
  return $decode.then$(
    $decode.string,
    (portal) => {
      if (portal === "one_trust") {
        return $decode.success(new OneTrust());
      } else {
        return $decode.failure(new OneTrust(), "Type");
      }
    },
  );
}

function resolve_source_filters_decoding(raw, tags) {
  if (raw instanceof Some) {
    let filters = raw[0];
    return filters;
  } else if (tags instanceof Some) {
    let included_tags = tags[0];
    let _pipe = $data_source.init_source_filters();
    return ((f) => {
      return new $data_source.SourceFilters(
        included_tags,
        f.excluded_tags,
        f.excluded_kinds,
      );
    })(_pipe);
  } else {
    return $data_source.init_source_filters();
  }
}

function questionnaire_decoder() {
  return $decrypt.optional_field(
    "tags",
    $decode.list($tag.decoder()),
    (tags) => {
      return $decrypt.optional_field(
        "source_filters",
        $data_source.source_filters_decoder(),
        (source_filters) => {
          let source_filters$1 = resolve_source_filters_decoding(
            source_filters,
            tags,
          );
          return $decrypt.optional_field(
            "style_guidelines",
            $style_guideline.decoder(),
            (style_guidelines) => {
              return $decrypt.optional_field(
                "proposal_context",
                $decode.string,
                (proposal_context) => {
                  return $decode.optional_field(
                    "languages",
                    toList([]),
                    languages_decoder(),
                    (languages) => {
                      let qm = $decode.list(decode_qualification_matrix());
                      return $decrypt.optional_field(
                        "qualification_matrix",
                        qm,
                        (qualification_matrix) => {
                          return $decrypt.optional_field(
                            "default_language",
                            $iso639.decoder(),
                            (default$) => {
                              return $decode.field(
                                "sheets",
                                $decode.list($decode.string),
                                (sheets) => {
                                  return $decode.field(
                                    "responses",
                                    $decode.list(
                                      decode_questionnaire_response(),
                                    ),
                                    (responses) => {
                                      return $decode.optional_field(
                                        "worksheets",
                                        toList([]),
                                        $spreadsheet.data_decoder(),
                                        (worksheets) => {
                                          return $decrypt.optional_field(
                                            "worksheets_key",
                                            $decode.string,
                                            (worksheets_key) => {
                                              return $decrypt.optional_field(
                                                "section_labels",
                                                $decode.list($decode.string),
                                                (section_labels) => {
                                                  return $decrypt.optional_field(
                                                    "notified",
                                                    $decode.bool,
                                                    (notified) => {
                                                      let notified$1 = $option.unwrap(
                                                        notified,
                                                        true,
                                                      );
                                                      return $decrypt.optional_field(
                                                        "project_file_id",
                                                        $decode.string,
                                                        (project_file_id) => {
                                                          return $decrypt.optional_field(
                                                            "origin",
                                                            $origin.decoder(),
                                                            (origin) => {
                                                              return $decode.success(
                                                                new Questionnaire(
                                                                  source_filters$1,
                                                                  style_guidelines,
                                                                  proposal_context,
                                                                  languages,
                                                                  qualification_matrix,
                                                                  default$,
                                                                  notified$1,
                                                                  project_file_id,
                                                                  origin,
                                                                  sheets,
                                                                  responses,
                                                                  worksheets,
                                                                  worksheets_key,
                                                                  section_labels,
                                                                ),
                                                              );
                                                            },
                                                          );
                                                        },
                                                      );
                                                    },
                                                  );
                                                },
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function narrative_decoder() {
  return $decrypt.optional_field(
    "tags",
    $decode.list($tag.decoder()),
    (tags) => {
      return $decrypt.optional_field(
        "source_filters",
        $data_source.source_filters_decoder(),
        (source_filters) => {
          let source_filters$1 = resolve_source_filters_decoding(
            source_filters,
            tags,
          );
          return $decrypt.optional_field(
            "style_guidelines",
            $style_guideline.decoder(),
            (style_guidelines) => {
              return $decrypt.optional_field(
                "proposal_context",
                $decode.string,
                (proposal_context) => {
                  return $decode.optional_field(
                    "languages",
                    toList([]),
                    languages_decoder(),
                    (languages) => {
                      let qm = $decode.list(decode_qualification_matrix());
                      return $decrypt.optional_field(
                        "qualification_matrix",
                        qm,
                        (qualification_matrix) => {
                          return $decrypt.optional_field(
                            "default_language",
                            $iso639.decoder(),
                            (default$) => {
                              return $decrypt.optional_field(
                                "notified",
                                $decode.bool,
                                (notified) => {
                                  let notified$1 = $option.unwrap(
                                    notified,
                                    true,
                                  );
                                  return $decrypt.optional_field(
                                    "requirements",
                                    $decode.list($decode.string),
                                    (requirements) => {
                                      return $decrypt.optional_field(
                                        "project_file_id",
                                        $decode.string,
                                        (project_file_id) => {
                                          return $decrypt.optional_field(
                                            "origin",
                                            $origin.decoder(),
                                            (origin) => {
                                              return $decode.success(
                                                new Narrative(
                                                  source_filters$1,
                                                  style_guidelines,
                                                  proposal_context,
                                                  languages,
                                                  qualification_matrix,
                                                  default$,
                                                  notified$1,
                                                  project_file_id,
                                                  origin,
                                                  requirements,
                                                ),
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function document_decoder() {
  return $decrypt.optional_field(
    "tags",
    $decode.list($tag.decoder()),
    (tags) => {
      return $decrypt.optional_field(
        "source_filters",
        $data_source.source_filters_decoder(),
        (source_filters) => {
          let source_filters$1 = resolve_source_filters_decoding(
            source_filters,
            tags,
          );
          return $decrypt.optional_field(
            "style_guidelines",
            $style_guideline.decoder(),
            (style_guidelines) => {
              return $decrypt.optional_field(
                "proposal_context",
                $decode.string,
                (proposal_context) => {
                  return $decode.optional_field(
                    "languages",
                    toList([]),
                    languages_decoder(),
                    (languages) => {
                      let qm = $decode.list(decode_qualification_matrix());
                      return $decrypt.optional_field(
                        "qualification_matrix",
                        qm,
                        (qualification_matrix) => {
                          return $decrypt.optional_field(
                            "default_language",
                            $iso639.decoder(),
                            (default$) => {
                              return $decrypt.optional_field(
                                "notified",
                                $decode.bool,
                                (notified) => {
                                  let notified$1 = $option.unwrap(
                                    notified,
                                    true,
                                  );
                                  return $decrypt.optional_field(
                                    "project_file_id",
                                    $decode.string,
                                    (project_file_id) => {
                                      return $decrypt.optional_field(
                                        "origin",
                                        $origin.decoder(),
                                        (origin) => {
                                          return $decode.success(
                                            new Document(
                                              source_filters$1,
                                              style_guidelines,
                                              proposal_context,
                                              languages,
                                              qualification_matrix,
                                              default$,
                                              notified$1,
                                              project_file_id,
                                              origin,
                                            ),
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function portal_decoder() {
  return $decrypt.optional_field(
    "tags",
    $decode.list($tag.decoder()),
    (tags) => {
      return $decrypt.optional_field(
        "source_filters",
        $data_source.source_filters_decoder(),
        (source_filters) => {
          let source_filters$1 = resolve_source_filters_decoding(
            source_filters,
            tags,
          );
          return $decrypt.optional_field(
            "style_guidelines",
            $style_guideline.decoder(),
            (style_guidelines) => {
              return $decrypt.optional_field(
                "proposal_context",
                $decode.string,
                (proposal_context) => {
                  return $decode.optional_field(
                    "languages",
                    toList([]),
                    languages_decoder(),
                    (languages) => {
                      let qm = $decode.list(decode_qualification_matrix());
                      return $decrypt.optional_field(
                        "qualification_matrix",
                        qm,
                        (qualification_matrix) => {
                          return $decrypt.optional_field(
                            "default_language",
                            $iso639.decoder(),
                            (default$) => {
                              return $decrypt.optional_field(
                                "notified",
                                $decode.bool,
                                (notified) => {
                                  let notified$1 = $option.unwrap(
                                    notified,
                                    true,
                                  );
                                  return $decode.field(
                                    "portal",
                                    portal_type_decoder(),
                                    (portal) => {
                                      return $decrypt.optional_field(
                                        "project_file_id",
                                        $decode.string,
                                        (project_file_id) => {
                                          return $decrypt.optional_field(
                                            "origin",
                                            $origin.decoder(),
                                            (origin) => {
                                              return $decode.success(
                                                new Portal(
                                                  source_filters$1,
                                                  style_guidelines,
                                                  proposal_context,
                                                  languages,
                                                  qualification_matrix,
                                                  default$,
                                                  notified$1,
                                                  project_file_id,
                                                  origin,
                                                  portal,
                                                ),
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function metadata_decoder() {
  return $decode.field(
    "type",
    $decode.string,
    (type_) => {
      if (type_ === "portal") {
        return portal_decoder();
      } else if (type_ === "document") {
        return document_decoder();
      } else if (type_ === "narrative") {
        return narrative_decoder();
      } else if (type_ === "questionnaire") {
        return questionnaire_decoder();
      } else {
        let _pipe = new Portal(
          $data_source.init_source_filters(),
          new None(),
          new None(),
          toList([]),
          new None(),
          new None(),
          false,
          new None(),
          new None(),
          new OneTrust(),
        );
        return $decode.failure(_pipe, "Metadata");
      }
    },
  );
}

export function display_decoder() {
  return $decode.field(
    "type",
    $decode.string,
    (type_) => {
      return $decode.optional_field(
        "syncing",
        false,
        $decode.bool,
        (syncing) => { return $decode.success(new Display(type_, syncing)); },
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "id",
    $decrypt.uuid(),
    (id) => {
      return $decode.field(
        "display",
        $decrypt.json(display_decoder()),
        (display) => {
          return $decode.field(
            "org_id",
            $decode.string,
            (org_id) => {
              return $decode.field(
                "name",
                $decode.string,
                (name) => {
                  return $decode.field(
                    "progress",
                    $decode.int,
                    (progress) => {
                      return $decode.field(
                        "status",
                        $status.decoder(),
                        (status) => {
                          return $decode.field(
                            "metadata",
                            $decrypt.json(metadata_decoder()),
                            (metadata) => {
                              return $decode.field(
                                "created_at",
                                $decrypt.timestamp(),
                                (created_at) => {
                                  return $decode.field(
                                    "kind",
                                    kind_decoder(),
                                    (kind) => {
                                      return $decode.field(
                                        "project_id",
                                        (() => {
                                          let _pipe = $decrypt.uuid();
                                          let _pipe$1 = $decode.optional(_pipe);
                                          return $decode.map(
                                            _pipe$1,
                                            (_capture) => {
                                              return $option.unwrap(
                                                _capture,
                                                "unknown",
                                              );
                                            },
                                          );
                                        })(),
                                        (project_id) => {
                                          return $decode.field(
                                            "google_sheet_id",
                                            $decode.optional($decode.string),
                                            (google_sheet_id) => {
                                              return $decode.field(
                                                "link_id",
                                                $decode.optional($decode.string),
                                                (link_id) => {
                                                  return $decode.field(
                                                    "domain",
                                                    $decode.optional(
                                                      $decode.string,
                                                    ),
                                                    (domain) => {
                                                      return $decrypt.optional_field(
                                                        "version",
                                                        version_decoder(),
                                                        (version) => {
                                                          let version$1 = $option.unwrap(
                                                            version,
                                                            new V1(),
                                                          );
                                                          let _block;
                                                          if (
                                                            version$1 instanceof V4 &&
                                                            metadata instanceof Questionnaire
                                                          ) {
                                                            let questionnaire = metadata;
                                                            let worksheets = metadata.worksheets;
                                                            _block = new Questionnaire(
                                                              questionnaire.source_filters,
                                                              questionnaire.style_guidelines,
                                                              questionnaire.proposal_context,
                                                              questionnaire.languages,
                                                              questionnaire.qualification_matrix,
                                                              questionnaire.default_language,
                                                              questionnaire.notified,
                                                              questionnaire.project_file_id,
                                                              questionnaire.origin,
                                                              questionnaire.sheets,
                                                              questionnaire.responses,
                                                              $list.map(
                                                                worksheets,
                                                                $spreadsheet.ensure_cell_mapping,
                                                              ),
                                                              questionnaire.worksheets_key,
                                                              questionnaire.section_labels,
                                                            );
                                                          } else {
                                                            _block = metadata;
                                                          }
                                                          let metadata$1 = _block;
                                                          return $decode.success(
                                                            new Proposal(
                                                              id,
                                                              project_id,
                                                              org_id,
                                                              name,
                                                              status,
                                                              display,
                                                              google_sheet_id,
                                                              kind,
                                                              link_id,
                                                              domain,
                                                              metadata$1,
                                                              progress,
                                                              created_at,
                                                              version$1,
                                                            ),
                                                          );
                                                        },
                                                      );
                                                    },
                                                  );
                                                },
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function count_qualification_matrix_answers(qualification_matrix) {
  return $list.fold(
    qualification_matrix,
    [0.0, 0.0, 0.0],
    (_use0, val) => {
      let yes = _use0[0];
      let no = _use0[1];
      let total = _use0[2];
      let total$1 = total + 1.0;
      let $ = val[1];
      if ($ instanceof $qualification_matrix.Yes) {
        return [yes + 1.0, no, total$1];
      } else if ($ instanceof $qualification_matrix.No) {
        return [yes, no + 1.0, total$1];
      } else {
        return [yes, no, total$1];
      }
    },
  );
}

export function initial_question_kinds(proposal, sheet) {
  let $ = proposal.metadata;
  if ($ instanceof Portal) {
    return $question.default_kinds(toList([]));
  } else if ($ instanceof Document) {
    return $question.default_kinds(toList([]));
  } else if ($ instanceof Questionnaire) {
    let responses = $.responses;
    let _pipe = $list.filter_map(
      responses,
      (response) => {
        let $1 = isEqual(new Some(response.name), sheet);
        if ($1) {
          return new Ok(response.kind);
        } else {
          return new Error(undefined);
        }
      },
    );
    let _pipe$1 = $list.unique(_pipe);
    return $question.default_kinds(_pipe$1);
  } else {
    return $question.default_kinds(toList([]));
  }
}

export function is_narrative(proposal) {
  let $ = proposal.metadata;
  if ($ instanceof Portal) {
    return false;
  } else if ($ instanceof Document) {
    return false;
  } else if ($ instanceof Questionnaire) {
    return false;
  } else {
    return true;
  }
}

export function completed(proposal) {
  return !(proposal.status instanceof $status.InProgress);
}

export function update_source_filters(proposal, source_filters) {
  let metadata = proposal.metadata;
  return new Proposal(
    proposal.id,
    proposal.project_id,
    proposal.org_id,
    proposal.name,
    proposal.status,
    proposal.display,
    proposal.google_sheet_id,
    proposal.kind,
    proposal.link_id,
    proposal.domain,
    (() => {
      if (metadata instanceof Portal) {
        return new Portal(
          source_filters,
          metadata.style_guidelines,
          metadata.proposal_context,
          metadata.languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
          metadata.portal,
        );
      } else if (metadata instanceof Document) {
        return new Document(
          source_filters,
          metadata.style_guidelines,
          metadata.proposal_context,
          metadata.languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
        );
      } else if (metadata instanceof Questionnaire) {
        return new Questionnaire(
          source_filters,
          metadata.style_guidelines,
          metadata.proposal_context,
          metadata.languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
          metadata.sheets,
          metadata.responses,
          metadata.worksheets,
          metadata.worksheets_key,
          metadata.section_labels,
        );
      } else {
        return new Narrative(
          source_filters,
          metadata.style_guidelines,
          metadata.proposal_context,
          metadata.languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
          metadata.requirements,
        );
      }
    })(),
    proposal.progress,
    proposal.created_at,
    proposal.version,
  );
}

export function update_name(proposal, name) {
  return new Proposal(
    proposal.id,
    proposal.project_id,
    proposal.org_id,
    name,
    proposal.status,
    proposal.display,
    proposal.google_sheet_id,
    proposal.kind,
    proposal.link_id,
    proposal.domain,
    proposal.metadata,
    proposal.progress,
    proposal.created_at,
    proposal.version,
  );
}

export function update_languages(proposal, languages) {
  let metadata = proposal.metadata;
  return new Proposal(
    proposal.id,
    proposal.project_id,
    proposal.org_id,
    proposal.name,
    proposal.status,
    proposal.display,
    proposal.google_sheet_id,
    proposal.kind,
    proposal.link_id,
    proposal.domain,
    (() => {
      if (metadata instanceof Portal) {
        return new Portal(
          metadata.source_filters,
          metadata.style_guidelines,
          metadata.proposal_context,
          languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
          metadata.portal,
        );
      } else if (metadata instanceof Document) {
        return new Document(
          metadata.source_filters,
          metadata.style_guidelines,
          metadata.proposal_context,
          languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
        );
      } else if (metadata instanceof Questionnaire) {
        return new Questionnaire(
          metadata.source_filters,
          metadata.style_guidelines,
          metadata.proposal_context,
          languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
          metadata.sheets,
          metadata.responses,
          metadata.worksheets,
          metadata.worksheets_key,
          metadata.section_labels,
        );
      } else {
        return new Narrative(
          metadata.source_filters,
          metadata.style_guidelines,
          metadata.proposal_context,
          languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
          metadata.requirements,
        );
      }
    })(),
    proposal.progress,
    proposal.created_at,
    proposal.version,
  );
}

export function update_proposal_context(proposal, proposal_context) {
  let metadata = proposal.metadata;
  return new Proposal(
    proposal.id,
    proposal.project_id,
    proposal.org_id,
    proposal.name,
    proposal.status,
    proposal.display,
    proposal.google_sheet_id,
    proposal.kind,
    proposal.link_id,
    proposal.domain,
    (() => {
      if (metadata instanceof Portal) {
        return new Portal(
          metadata.source_filters,
          metadata.style_guidelines,
          proposal_context,
          metadata.languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
          metadata.portal,
        );
      } else if (metadata instanceof Document) {
        return new Document(
          metadata.source_filters,
          metadata.style_guidelines,
          proposal_context,
          metadata.languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
        );
      } else if (metadata instanceof Questionnaire) {
        return new Questionnaire(
          metadata.source_filters,
          metadata.style_guidelines,
          proposal_context,
          metadata.languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
          metadata.sheets,
          metadata.responses,
          metadata.worksheets,
          metadata.worksheets_key,
          metadata.section_labels,
        );
      } else {
        return new Narrative(
          metadata.source_filters,
          metadata.style_guidelines,
          proposal_context,
          metadata.languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
          metadata.requirements,
        );
      }
    })(),
    proposal.progress,
    proposal.created_at,
    proposal.version,
  );
}

export function update_style_guidelines(proposal, style_guidelines) {
  let metadata = proposal.metadata;
  return new Proposal(
    proposal.id,
    proposal.project_id,
    proposal.org_id,
    proposal.name,
    proposal.status,
    proposal.display,
    proposal.google_sheet_id,
    proposal.kind,
    proposal.link_id,
    proposal.domain,
    (() => {
      if (metadata instanceof Portal) {
        return new Portal(
          metadata.source_filters,
          style_guidelines,
          metadata.proposal_context,
          metadata.languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
          metadata.portal,
        );
      } else if (metadata instanceof Document) {
        return new Document(
          metadata.source_filters,
          style_guidelines,
          metadata.proposal_context,
          metadata.languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
        );
      } else if (metadata instanceof Questionnaire) {
        return new Questionnaire(
          metadata.source_filters,
          style_guidelines,
          metadata.proposal_context,
          metadata.languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
          metadata.sheets,
          metadata.responses,
          metadata.worksheets,
          metadata.worksheets_key,
          metadata.section_labels,
        );
      } else {
        return new Narrative(
          metadata.source_filters,
          style_guidelines,
          metadata.proposal_context,
          metadata.languages,
          metadata.qualification_matrix,
          metadata.default_language,
          metadata.notified,
          metadata.project_file_id,
          metadata.origin,
          metadata.requirements,
        );
      }
    })(),
    proposal.progress,
    proposal.created_at,
    proposal.version,
  );
}

export function syncing(proposal, syncing) {
  let _block;
  let _record = proposal.display;
  _block = new Display(_record.type_, syncing);
  let display = _block;
  return new Proposal(
    proposal.id,
    proposal.project_id,
    proposal.org_id,
    proposal.name,
    proposal.status,
    display,
    proposal.google_sheet_id,
    proposal.kind,
    proposal.link_id,
    proposal.domain,
    proposal.metadata,
    proposal.progress,
    proposal.created_at,
    proposal.version,
  );
}

export function mime_type(proposal) {
  let $ = proposal.metadata;
  if ($ instanceof Portal) {
    return new $mime_types.Qna();
  } else if ($ instanceof Document) {
    return new $mime_types.Document();
  } else if ($ instanceof Questionnaire) {
    return new $mime_types.Xlsx();
  } else {
    return new $mime_types.Document();
  }
}

export function type_(proposal) {
  let $ = proposal.metadata;
  if ($ instanceof Portal) {
    return "portal";
  } else if ($ instanceof Document) {
    return "doc";
  } else if ($ instanceof Questionnaire) {
    return "sheet";
  } else {
    return "narrative";
  }
}

export function has_multiple_languages(proposal) {
  let $ = proposal.metadata.languages;
  if ($ instanceof $Empty) {
    return false;
  } else {
    let $1 = $.tail;
    if ($1 instanceof $Empty) {
      return false;
    } else {
      return true;
    }
  }
}

export function is_default_language(proposal, language) {
  return isEqual(new Some(language), proposal.metadata.default_language);
}

export function should_retrigger_questions(old, new$) {
  return ((!isEqual(
    old.metadata.proposal_context,
    new$.metadata.proposal_context
  )) || (!isEqual(old.metadata.style_guidelines, new$.metadata.style_guidelines))) || (!isEqual(
    $data_source.sort_filters(old.metadata.source_filters),
    $data_source.sort_filters(new$.metadata.source_filters)
  ));
}

/**
 * Trims a header text the same way on Erlang and JavaScript. `string.trim`
 * also removes U+200E and U+200F on Erlang, but not on JavaScript. Heimdall
 * and the browser look up translations by this text, so both must get the
 * same result.
 */
export function trim_section_text(loop$text) {
  while (true) {
    let text = loop$text;
    let text$1 = $string.trim(text);
    let $ = text$1.charCodeAt(0);
    if ($ === 8206) {
      let rest = text$1.slice(1);
      loop$text = rest;
    } else if ($ === 8207) {
      let rest = text$1.slice(1);
      loop$text = rest;
    } else {
      let $1 = $string.ends_with(text$1, "\u{200E}") || $string.ends_with(
        text$1,
        "\u{200F}",
      );
      if ($1) {
        loop$text = $string.drop_end(text$1, 1);
      } else {
        return text$1;
      }
    }
  }
}

function worksheet_section_cells(worksheet) {
  if (worksheet instanceof $spreadsheet.Worksheet) {
    let name = worksheet.name;
    let cell_mapping = worksheet.cell_mapping;
    let _pipe = $dict.values(cell_mapping);
    let _pipe$1 = $list.flat_map(
      _pipe,
      (mapping) => {
        let targets = $list.filter_map(
          mapping.edges,
          (edge) => {
            if (edge instanceof $cell_mapping.HeaderSource) {
              let target = edge.target;
              return new Ok(target);
            } else {
              return new Error(undefined);
            }
          },
        );
        let $ = mapping.cell_type;
        if ($ === "header") {
          return listPrepend(mapping.anchor, targets);
        } else if ($ === "section") {
          return listPrepend(mapping.anchor, targets);
        } else if ($ === "subsection") {
          return listPrepend(mapping.anchor, targets);
        } else {
          return targets;
        }
      },
    );
    let _pipe$2 = $list.unique(_pipe$1);
    return $list.filter_map(
      _pipe$2,
      (position) => {
        let column = position[0];
        let row = position[1];
        return $result.try$(
          $spreadsheet.cell(worksheet, column, row),
          (cell) => {
            return $result.try$(
              $option.to_result(cell.value, undefined),
              (value) => {
                let $ = trim_section_text(value);
                if ($ === "") {
                  return new Error(undefined);
                } else {
                  let text = $;
                  return new Ok(new SectionCell(name, position, text));
                }
              },
            );
          },
        );
      },
    );
  } else {
    return toList([]);
  }
}

/**
 * Returns the header cells of all worksheets, with trimmed text.
 */
export function section_cells(proposal) {
  let $ = proposal.metadata;
  if ($ instanceof Questionnaire) {
    let worksheets = $.worksheets;
    return $list.flat_map(worksheets, worksheet_section_cells);
  } else {
    return toList([]);
  }
}

/**
 * Returns the header texts to translate. Each text occurs one time.
 */
export function section_labels(proposal) {
  let _pipe = section_cells(proposal);
  let _pipe$1 = $list.map(_pipe, (cell) => { return cell.text; });
  return $list.unique(_pipe$1);
}

function compute_from_columns_rows(worksheet, y) {
  return $result.map(
    $list_.at(worksheet.content, y),
    (row) => {
      let columns_type = $dict.to_list(worksheet.columns_type);
      let rows_type = $dict.to_list(worksheet.rows_type);
      return new $question.AdditionalInformation(
        (() => {
          let _pipe = rows_type;
          let _pipe$1 = $list.filter(
            _pipe,
            (r) => { return $spreadsheet.is_header(r[1]) && (r[0] < y); },
          );
          let _pipe$2 = $list.sort(
            _pipe$1,
            (a, b) => { return $int.compare(a[0], b[0]); },
          );
          return $list.filter_map(
            _pipe$2,
            (row) => {
              let _pipe$3 = $list.find_map(
                columns_type,
                (c) => {
                  let index = c[0];
                  let type_$1 = c[1];
                  if (type_$1 instanceof $spreadsheet.ContextColumn) {
                    return new Error(undefined);
                  } else if (type_$1 instanceof $spreadsheet.AnswerColumn) {
                    return new Error(undefined);
                  } else if (type_$1 instanceof $spreadsheet.CategoryColumn) {
                    return new Error(undefined);
                  } else if (
                    type_$1 instanceof $spreadsheet.MultipleChoiceColumn
                  ) {
                    return new Error(undefined);
                  } else if (type_$1 instanceof $spreadsheet.YesNoColumn) {
                    return new Error(undefined);
                  } else if (type_$1 instanceof $spreadsheet.NumberingColumn) {
                    return new Error(undefined);
                  } else if (type_$1 instanceof $spreadsheet.QuestionColumn) {
                    return new Ok(index);
                  } else if (type_$1 instanceof $spreadsheet.TagColumn) {
                    return new Error(undefined);
                  } else {
                    return new Error(undefined);
                  }
                },
              );
              return $result.try$(
                _pipe$3,
                (col) => {
                  return $result.try$(
                    $list_.at(worksheet.content, row[0]),
                    (row_cells) => {
                      return $result.try$(
                        $list_.at(row_cells, col),
                        (cell) => {
                          return $option.to_result(cell.value, undefined);
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        })(),
        (() => {
          let _pipe = columns_type;
          let _pipe$1 = $list.filter(
            _pipe,
            (c) => { return c[1] instanceof $spreadsheet.NumberingColumn; },
          );
          let _pipe$2 = $list.sort(
            _pipe$1,
            (a, b) => { return $int.compare(a[0], b[0]); },
          );
          return $list.filter_map(
            _pipe$2,
            (col) => {
              return $result.try$(
                $list_.at(row, col[0]),
                (cell) => {
                  return $result.try$(
                    $option.to_result(cell.value, undefined),
                    (value) => {
                      let value$1 = $string.trim(value);
                      return $bool.guard(
                        value$1 === "",
                        new Error(undefined),
                        () => { return new Ok(value$1); },
                      );
                    },
                  );
                },
              );
            },
          );
        })(),
      );
    },
  );
}

function compute_from_cell_mapping(worksheet, mapping) {
  return new $question.AdditionalInformation(
    (() => {
      let _pipe = mapping.edges;
      let _pipe$1 = $list.filter_map(
        _pipe,
        (edge) => {
          if (edge instanceof $cell_mapping.HeaderSource) {
            let ex = edge.target[0];
            let ey = edge.target[1];
            return $result.try$(
              $spreadsheet.cell(worksheet, ex, ey),
              (cell) => {
                return $result.try$(
                  $option.to_result(cell.value, undefined),
                  (value) => {
                    let value$1 = $string.trim(value);
                    return $bool.guard(
                      value$1 === "",
                      new Error(undefined),
                      () => { return new Ok([ey, value$1]); },
                    );
                  },
                );
              },
            );
          } else {
            return new Error(undefined);
          }
        },
      );
      let _pipe$2 = $list.sort(
        _pipe$1,
        (a, b) => { return $int.compare(a[0], b[0]); },
      );
      return $list.map(_pipe$2, $pair.second);
    })(),
    (() => {
      let _pipe = mapping.edges;
      let _pipe$1 = $list.filter_map(
        _pipe,
        (edge) => {
          if (edge instanceof $cell_mapping.NumberingSource) {
            let ex = edge.target[0];
            let ey = edge.target[1];
            return $result.try$(
              $spreadsheet.cell(worksheet, ex, ey),
              (cell) => {
                return $result.try$(
                  $option.to_result(cell.value, undefined),
                  (value) => {
                    let value$1 = $string.trim(value);
                    return $bool.guard(
                      value$1 === "",
                      new Error(undefined),
                      () => { return new Ok([ex, value$1]); },
                    );
                  },
                );
              },
            );
          } else {
            return new Error(undefined);
          }
        },
      );
      let _pipe$2 = $list.sort(
        _pipe$1,
        (a, b) => { return $int.compare(a[0], b[0]); },
      );
      return $list.map(_pipe$2, $pair.second);
    })(),
  );
}

function compute_additional_information(worksheets, name, x, y) {
  return $result.try$(
    $list.find(worksheets, (ws) => { return ws.name === name; }),
    (worksheet) => {
      let _block;
      if (worksheet instanceof $spreadsheet.Worksheet) {
        let cell_mapping = worksheet.cell_mapping;
        _block = $dict.get(cell_mapping, [x, y]);
      } else {
        _block = new Error(undefined);
      }
      let mapping = _block;
      if (mapping instanceof Ok) {
        let mapping$1 = mapping[0];
        return new Ok(compute_from_cell_mapping(worksheet, mapping$1));
      } else {
        return compute_from_columns_rows(worksheet, y);
      }
    },
  );
}

export function additional_question_information(proposal, question) {
  let $ = question.metadata;
  let $1 = proposal.metadata;
  if ($ instanceof $question.PortalQuestion) {
    let m = $;
    return new $question.AdditionalInformation(
      toList([m.section_name]),
      toList([]),
    );
  } else {
    let $2 = $.position;
    if ($2 instanceof Some) {
      let $3 = $.sheet_name;
      if ($3 instanceof Some && $1 instanceof Questionnaire) {
        let m = $1;
        let name = $3[0];
        let x = $2[0][0];
        let y = $2[0][1];
        let _pipe = m.worksheets;
        let _pipe$1 = compute_additional_information(_pipe, name, x, y);
        return $result.lazy_unwrap(_pipe$1, $question.no_information);
      } else {
        return $question.no_information();
      }
    } else {
      return $question.no_information();
    }
  }
}
